import { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { Modal } from "@/components/ui/Modal";

export default function DeleteConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  interviewerName, 
  interviewerEmail,
  isDeleting = false 
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Interviewer"
    >
      <div className="space-y-6">
        {/* Warning Icon */}
        <div className="flex justify-center">
          <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-destructive" />
          </div>
        </div>

        {/* Warning Message */}
        <div className="text-center space-y-3">
          <h3 className="text-lg font-semibold text-foreground">
            Are you sure you want to delete this interviewer?
          </h3>
          <div className="space-y-2">
            <p className="text-muted-foreground">
              This action cannot be undone. The interviewer will be permanently removed from the system.
            </p>
            {interviewerName && (
              <div className="bg-secondary border text-start border-secondary-border rounded-lg p-3">
                <p className="text-sm text-foreground">
                  <span className="font-medium">Name:</span> {interviewerName}
                </p>
                <p className="text-sm text-foreground">
                  <span className="font-medium">Email:</span> {interviewerEmail}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 bg-secondary border border-secondary-border text-foreground px-4 py-2 rounded-[4px] hover:bg-secondary/90 transition-colors"
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 bg-destructive text-white px-4 py-2 rounded-[4px] hover:bg-destructive/90 transition-colors flex items-center justify-center"
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <Loader2 className="animate-spin mr-2" size={16} />
                Deleting...
              </>
            ) : (
              'Yes, Delete'
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
} 